import React from 'react';
import {
  FraudTokensTable,
  SuspiciousMessageReportsTable,
} from '../components/FraudScanner';
import { Tabs, Tab, Box } from '@mui/material';

import { useState } from 'react';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`fraud-scanner-tabpanel-${index}`}
      aria-labelledby={`fraud-scanner-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}
const tabs = [
  {
    label: 'Suspicious Message Reports',
    component: <SuspiciousMessageReportsTable />,
  },
  {
    label: 'Fraud Tokens',
    component: <FraudTokensTable />,
  },
];

function a11yProps(index: number) {
  return {
    id: `fraud-scanner-tab-${index}`,
    'aria-controls': `fraud-scanner-tabpanel-${index}`,
  };
}

export const FraudScanner = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} {...a11yProps(index)} />
        ))}
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        <SuspiciousMessageReportsTable />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <FraudTokensTable />
      </TabPanel>
    </Box>
  );
};

export default FraudScanner;
